import {lazy} from 'react';

import {ReportAccessGuard, useImporterReportingIntegrations} from '@dms/shared-aftersales';

const Reports = lazy(() => import('./components/Reports'));

export function HyundaiMobisIrisReport() {
  const {isHyundaiMobisIrisEnabled, isLoading, isError} = useImporterReportingIntegrations();

  return (
    <ReportAccessGuard
      hasAccess={isHyundaiMobisIrisEnabled}
      isLoading={isLoading}
      isError={isError}
      data-testid="hyundaiMobisIrisReport"
    >
      <Reports />
    </ReportAccessGuard>
  );
}
